import isTestIP from './urltestip'
import isTest from './urltest'

var EDS_BASE_URL = 'https://edscloud.hzdatalink.com'

if (isTest) {
  EDS_BASE_URL = 'https://edscloudtest.hzdatalink.com'
}

if (isTestIP) {
  EDS_BASE_URL = 'http://192.9.200.113:5511'
}

//-----------------------------------------

// var FILE_BASE_URL = EDS_BASE_URL

var API_V1_AUTH = '/api/v1/auth'

var API_V1_AUTH_TOKEN_PATH = '/api/v1/auth/token'

var API_V1_AUTH_TOKEN_REFRESH_PATH = '/api/v1/auth/refresh-token'

var API_V1_USERS_SESSIONS = '/api/v1/user-msg-sessions'

var API_V1_TENANTS = '/api/v1/tenants'

var API_V1_LICENCE = '/api/v1/eula'

var API_V1_PRIVACY = '/api/v1/privacy-policy'


//-----------------------------------------


// 当前用户信息
var API_V1_CURRENT_USER = '/api/v1/current-token-user'

// 消息相关接口
var API_V1_ORDERMSGS = '/api/v1/ordermsgs'

// 组织相关接口
var API_V1_ORGS = '/api/v1/orgs'

// 角色相关接口
var API_V1_ROLES = '/api/v1/roles'

// 权限相关接口
var API_V1_RIGHTS = '/api/v1/rights'

// 手机验证码相关接口
var API_V1_VCODE = '/api/v1/auth/vcode'

// 发送邮箱验证码相关接口
var API_V1_SENT_VEMAIL = '/api/v1/auth/vemail'

// 文件上传下载相关
var API_V1_FS = '/fs'

var API_V1_FS_TOKEN = '/api/v1/auth/fstoken'

var API_V1_PUT_FILE = '/fs/upload?bucket=attachments&token='

var API_V1_PUT_RECEIPT_FILE = '/fs/upload?bucket=receipt&token='

var API_CHECK_VER = '/api/v1/releases/android/latest'

var API_CHECK_IOSVER = '/api/v1/releases/ios/latest'

// 消息批量确认
var API_V1_BATCH_READ_MSG = '/api/v1/batch/ordermsgs/process'

var API_V1_BAIDU_OAUTH2_CLIENT_REDENTIALS =
  '/api/v1/assistant/baidu_oauth2_client_credentials'

var API_V1_CONFIG = '/api/v1/configs'

// 文件下载
var API_DOWNLOAD_URL = '/api/v1/download'
var API_DOWNLOAD_FILES_URL = '/api/v1/download-files'



//-------------------------------------------------

// const FS_URL = FILE_BASE_URL + API_V1_FS

// const FS_TOKEN_URL = FILE_BASE_URL + API_V1_FS_TOKEN

// const FS_PUT_URL = FILE_BASE_URL + API_V1_PUT_FILE

// const FS_PUT_RECEIPT_URL = FILE_BASE_URL + API_V1_PUT_RECEIPT_FILE

// const BATCH_READ_MSG_URL = BASE_URL + API_V1_BATCH_READ_MSG

// const FETCH_TTS_TOKEN = BASE_URL + API_V1_BAIDU_OAUTH2_CLIENT_REDENTIALS

// const CONFIG_URL = BASE_URL + API_V1_CONFIG


//------------------------------------------

const EDS_AUTH_URL = EDS_BASE_URL + API_V1_AUTH

const EDS_LOGIN_URL = EDS_BASE_URL + API_V1_AUTH_TOKEN_PATH

const EDS_LOGIN_REFRESH_URL = EDS_BASE_URL + API_V1_AUTH_TOKEN_REFRESH_PATH

const EDS_USERS_SESSIONS_URL = EDS_BASE_URL + API_V1_USERS_SESSIONS

const EDS_TENANTS_URL = EDS_BASE_URL + API_V1_TENANTS

const EDS_LICENCE_URL = EDS_BASE_URL + API_V1_LICENCE

const EDS_PRIVACY_URL = EDS_BASE_URL + API_V1_PRIVACY

const EDS_VCODE_URL = EDS_BASE_URL + API_V1_VCODE

const EDS_SENT_VEMAIL_URL = EDS_BASE_URL + API_V1_SENT_VEMAIL

const EDS_CHECK_VER_URL = EDS_BASE_URL + API_CHECK_VER

const EDS_CHECK_IOSVER_URL = EDS_BASE_URL + API_CHECK_IOSVER


const URLS = {
  EDS_BASE_URL,

  // BASE_URL,

  // FILE_BASE_URL,

  EDS_AUTH_URL,

  EDS_LOGIN_URL,

  EDS_LOGIN_REFRESH_URL,

  EDS_USERS_SESSIONS_URL,

  EDS_TENANTS_URL,

  EDS_LICENCE_URL,

  EDS_PRIVACY_URL,

  EDS_VCODE_URL,

  EDS_SENT_VEMAIL_URL,

  EDS_CHECK_VER_URL,

  EDS_CHECK_IOSVER_URL,

  //--------------------

  // FS_URL,

  // FS_TOKEN_URL,

  // FS_PUT_URL,

  // FS_PUT_RECEIPT_URL,

  // BATCH_READ_MSG_URL,

  // FETCH_TTS_TOKEN,

  // CONFIG_URL,

  API_DOWNLOAD_FILES_URL,

}

export { URLS }
